import { TrackNextIcon, TrackPreviousIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useSmartPlayerContext } from '../context/SmartPlayerContext';
import { useTranslation } from 'react-i18next';

export const SmartPlayerFrameNav = ({
    direction,
}: {
    direction: 'forward' | 'backward';
}) => {
    const { t } = useTranslation('smartPlayer');
    const remote = useMediaRemote();
    const currentTime = useMediaState('currentTime');
    const { fps } = useSmartPlayerContext();

    const handleStep = (e: React.MouseEvent) => {
        e.stopPropagation();
        const frameDuration = 1 / fps;
        const targetTime =
            direction === 'forward'
                ? currentTime + frameDuration
                : currentTime - frameDuration;
        remote.seek(targetTime);
    };

    return (
        <IconButton
            size='2'
            variant='ghost'
            color='gray'
            highContrast
            onClick={handleStep}
            style={{ cursor: 'pointer', color: 'white' }}
            title={
                direction === 'forward'
                    ? t('controls.next_frame')
                    : t('controls.previous_frame')
            }
        >
            {direction === 'forward' ? (
                <TrackNextIcon width='18' height='18' />
            ) : (
                <TrackPreviousIcon width='18' height='18' />
            )}
        </IconButton>
    );
};
